import { createSlice } from "@reduxjs/toolkit";

import { IUserState, SignedInUser } from "@src/store/slices/user/types";

const initialState: IUserState = {};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: (create) => ({
    initUser: create.reducer<SignedInUser>((state, action) => {
      state.user = action.payload;
    }),
  }),
  selectors: {
    getUser: (state) => state.user,
    /** Trimmed, and undefined when absent — `firstName` is nullish on the DTO. */
    getUserFirstName: (state) => state.user?.firstName?.trim() || undefined,
  },
});

export const { initUser } = slice.actions;
export const { getUser, getUserFirstName } = slice.selectors;
export const userReducer = slice.reducer;
